import style from "./LoginForm.module.css";
import { useTranslation } from "react-i18next";
import { useLogin } from "../../hooks/useLogin";
import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import GoogleButton from "../googleButton/GoogleButton";

import InputPassword from "@/features/forms/components/InputPassword";
import FormInput from "@/features/forms/components/FormInput";
import { FormProvider, useForm } from "react-hook-form";

import Spinner from "@/features/forms/components/Spinner";

import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";

import { Link } from "react-router-dom";

export function LoginForm() {
	const { t } = useTranslation();
	const { login } = useLogin();

	const formMethods = useFormWithValidation();
	const {
		handleSubmit,
		formState: { isSubmitting },
	} = formMethods;

	return (
		<div className={style.holder}>
			<div className={style.subheader}>
				<h2>{t("auth:login.title")}</h2>
			</div>
			<FormProvider {...formMethods}>
				<form onSubmit={handleSubmit(login)} className={style.form}>
					<FormInput
						name="username"
						label={t("auth:login.username.label")}
						placeholder={t("auth:login.username.placeholder")}
					/>
					<InputPassword
						name="password"
						label={t("common:fields.password.label")}
						placeholder={t("common:fields.password.placeholder")}
						type="password"
					/>
					<Link
						to="/forgot-password"
						className={style.forgetPassword}
					>
						{t("auth:login.forgotPassword")}
					</Link>
					<Button type="accent" className={style.btn}>
						{isSubmitting ? (
							<Spinner />
						) : (
							<>
								<span>{t("auth:login.submit")}</span>{" "}
								<Icon icon="fa-arrow-right" />
							</>
						)}
					</Button>
				</form>
			</FormProvider>
			<div className={style.orSeparator}>
				<span className={style.line}></span>
				<p>{t("common:divider.or")}</p>
				<span className={style.line}></span>
			</div>
			<GoogleButton />
		</div>
	);
}
